import React from 'react';

export const defaultUserContext: UserContext = {
  setContext: () => {}
};

export default React.createContext<UserContext>(defaultUserContext);
